import {Injectable} from '@angular/core';
import {Http} from '@angular/http';
import {Cam} from './cam';

@Injectable()
export class CamService {
    constructor(private http: Http) {
        this.http = http;
    }

    public getCams(): Promise<Cam[]> {
        return new Promise((resolve, reject) => {
            let cams: Cam[];
            cams = this.loadCams();

            if (!cams) {
                cams = this.loadMockData();
            }

            resolve(cams);
        });
    }

    public updateCam(cam: Cam): void {
        this.updateQuality(cam);
        this.updateOrientation(cam);
        this.updateColorEffect(cam);
    }

    public storeCams(cams: Cam[]): Promise<{}> {
        return new Promise((resolve, reject) => {
            localStorage.setItem('cams', JSON.stringify(cams));

            resolve();
        });
    }

    public loadCams(): Cam[] {
        let cams = JSON.parse(localStorage.getItem('cams')) as Cam[];

        if (cams) {
            return cams;
        } else {
            return null;
        }
    }

    public loadMockData(): Cam[] {
        return [
            new Cam('10.0.0.128', 'Kees')
        ];
    }

    private updateQuality(cam: Cam): void {
        this.callCamUrl([cam], '/settings/quality?set=' + cam.quality);
    }

    private updateOrientation(cam: Cam): void {
        this.callCamUrl([cam], '/settings/orientation?set=' + cam.orientation);
    }

    private updateColorEffect(cam: Cam): void {
        this.callCamUrl([cam], '/settings/coloreffect?set=' + cam.colorEffect);
    }

    private callCamUrl(cams: Cam[], urlPath: string) {
        for (let cam of cams) {
            let url: string = this.getCamUrl(cam, urlPath);

            console.log(url);
            this.http.get(url).subscribe();
        }
    }

    private getCamUrl(cam: Cam, page: string): string {
        return 'http://' + cam.ip + ':' + cam.port + page;
    }
}


// WEBPACK FOOTER //
// /data/workspace/projects/camhunter/src/app/cam.service.ts